import { connect } from 'react-redux';
import { getHistoryList, getHistoryListStatus } from '../../../../store/selectors/person.selectors';
import { getHistoryListBegin } from '../../../../store/actions/person.actions';
import History from './History';

const mapStateToProps = (state: any) => {
    const historyList = getHistoryList(state);
    const loading = getHistoryListStatus(state);
    return { historyList, loading };
};

const mapDispatchToProps = {
    getHistoryList: getHistoryListBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
